// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1663":"1a81f450","5133":"1a81f450","5163":"6d2ccf55","7761":"1a81f450","8465":"1a81f450"}[chunkId] + ".chunk.css";
};